<template>
<div>
  <span ref="fake" :style="{ fontSize: size+'px' }">{{ value }}</span>
  <masked-input v-if="cMask" ref="input" :type="cType" :value="value" @input="update()" @focus="focus()" @click="setKeyboard()"
         :style="{ fontSize: size+'px' }" :mask="cMask" :showMask="true" :keepCharPositions="true"></masked-input>
  <input v-else ref="input" :type="cType" :value="value" @input="update()"
         :style="{ fontSize: size+'px' }" autofocus />
</div>
</template>

<script>
import MaskedInput from 'vue-text-mask'

export default {
  props: ['value', 'type', 'mask'],

  data () {
    return {
      size: 46,
      width: 10
    }
  },

  computed: {
    cType () {
      switch (this.type) {
        case 'date':
        case 'birthdate':
        case 'zipcode':
        case 'cpf':
          return 'tel'

        case 'carplate':
          return 'text'

        default:
          return this.type
      }
    },
    cMask () {
      if (this.mask) {
        return this.mask
      }

      switch (this.type) {
        case 'birthdate':
          return [/[0-3]/, /[0-9]/, '/', /[0-1]/, /[0-9]/, '/', /[1-2]/, /[0,9]/, /[0-9]/, /[0-9]/]

        case 'carplate':
          return [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]

        case 'zipcode':
          return [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/]

        case 'cpf':
          return [/[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/]

        default:
          return false
      }
    }
  },

  components: {
    MaskedInput
  },

  methods: { 
    focus() {
      setTimeout( () => {
        let pos = this.$refs.input.$el.value.indexOf('_')        
        this.$refs.input.$el.selectionStart = this.$refs.input.$el.selectionEnd = pos
      }, 50)
    },

    setKeyboard() {
      if (this.type === 'carplate') {  
        const $el = this.cMask ? this.$refs.input.$el : this.$refs.input

        if ($el.selectionStart > 3) {
          $el.setAttribute('type', 'tel')
        } else {
          $el.setAttribute('type', 'text')
        }

        $el.focus()
      }
    },

    update() {

      const $el = this.cMask ? this.$refs.input.$el : this.$refs.input
      const $fake = this.$refs.fake

      if (this.type === 'email') {
        let interval = setInterval( () => { // +40
          if ($fake.clientWidth + 80 > window.innerWidth && this.size > 16) {
            this.size--
          } else if ($fake.clientWidth + 120 < window.innerWidth && this.size < 46) {
            this.size++
          } else {
            $el.style.width = $fake.clientWidth + 20 + 'px'
            clearInterval(interval)
          }
        }, 1000 / 60)
      } else {
        $fake.remove()
      }

      if (this.type === 'carplate') {     

        const selectionStart = $el.selectionStart
        $el.value = $el.value.toUpperCase()
        $el.selectionStart = $el.selectionEnd = selectionStart

        // change keyboard
        setTimeout(this.setKeyboard, 100)

      }

      this.$emit('input', $el.value)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/sass/variables';

input, span {
  font-family: $family-sans-serif;
}

input {
  color: $white-bis;
  background: transparent;
  border: none;
  outline: none;

  text-align: center;
  font-weight: bold;

  min-height: 60px;
  min-width: 50px;
  max-width: 100vw;
  display: block;
  margin: 0 auto;
}

span {
  position: absolute;
  top: 0; left: 0;
  font-weight: bold;

  max-height: 0;
  overflow: hidden;
}
</style>